// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 40vw;
  overflow-x: hidden;
}
.example-container {
  /*max-height: 20vh;*/
  height: 40vh;
  overflow: auto;
  overflow-x: hidden !important;
}

.example-container-big {
  /*max-height: 30vh;*/
  height: 30vh;
  overflow: auto;
  overflow-x: hidden;
}

.mat-row {
  height: auto;
}

.mat-header-row{
  height: auto;

}

.mat-icon-button {
  height: 30px !important;
  width: 30px !important;
}
.mat-column-descriptionSmall {
  /*min-width: 100px !important;*/
  width: 100px  !important;
  text-overflow: ellipsis;
  word-break: keep-all;
  overflow-x: hidden !important;
}

.mat-column-more {
  min-width: 30px !important;
  width: 30px  !important;
  text-overflow: ellipsis;
  word-break: keep-all;
  overflow-x: hidden !important;
}

.mat-column-code {
  min-width: 30px !important;
  width: 30px  !important;
  text-overflow: ellipsis;
  word-break: keep-all;
  overflow-x: hidden !important;
}

.mat-column-nameSmall {
  min-width: 70% !important;
  width: 70%  !important;
  text-overflow: ellipsis;
  word-break: keep-all;
  overflow-x: hidden !important;
}


.searchColor {
  color: lightgreen;
}

.buttonBilumina {
  background-color:#f89624;
  color:white;
  margin: 0;
  width:90px;
}
.iconSize {
  font-size: 50px;
}

.refresh {
  position: absolute;
  top: -45px;
  right: -20px;
}

.tableZoom {
  height: 70vh;
}

.addIcons{
  font-size: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/uredi-task/doloci-proces/doloci-proces.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;AAC/B;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":["table {\n  width: 40vw;\n  overflow-x: hidden;\n}\n.example-container {\n  /*max-height: 20vh;*/\n  height: 40vh;\n  overflow: auto;\n  overflow-x: hidden !important;\n}\n\n.example-container-big {\n  /*max-height: 30vh;*/\n  height: 30vh;\n  overflow: auto;\n  overflow-x: hidden;\n}\n\n.mat-row {\n  height: auto;\n}\n\n.mat-header-row{\n  height: auto;\n\n}\n\n.mat-icon-button {\n  height: 30px !important;\n  width: 30px !important;\n}\n.mat-column-descriptionSmall {\n  /*min-width: 100px !important;*/\n  width: 100px  !important;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n  overflow-x: hidden !important;\n}\n\n.mat-column-more {\n  min-width: 30px !important;\n  width: 30px  !important;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n  overflow-x: hidden !important;\n}\n\n.mat-column-code {\n  min-width: 30px !important;\n  width: 30px  !important;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n  overflow-x: hidden !important;\n}\n\n.mat-column-nameSmall {\n  min-width: 70% !important;\n  width: 70%  !important;\n  text-overflow: ellipsis;\n  word-break: keep-all;\n  overflow-x: hidden !important;\n}\n\n\n.searchColor {\n  color: lightgreen;\n}\n\n.buttonBilumina {\n  background-color:#f89624;\n  color:white;\n  margin: 0;\n  width:90px;\n}\n.iconSize {\n  font-size: 50px;\n}\n\n.refresh {\n  position: absolute;\n  top: -45px;\n  right: -20px;\n}\n\n.tableZoom {\n  height: 70vh;\n}\n\n.addIcons{\n  font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
